import Form from "react-bootstrap/Form";

const ClientTypeDropdown = ({ selectedClientType, onClientTypeChange }) => {
  const clientTypeOptions = [
    { value: "", label: "Tous les types" },
    { value: "fournisseur", label: "🏢 Fournisseur" },
    { value: "particulier", label: "👤 Particulier" },
    { value: "entreprise", label: "💼 Entreprise" }
  ];

  return (
    <Form.Select
      value={selectedClientType}
      onChange={(e) => onClientTypeChange(e.target.value)}
      style={{ width: "auto" }}
    >
      {clientTypeOptions.map((type) => (
        <option key={type.value} value={type.value}>
          {type.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default ClientTypeDropdown;
